import {useEffect, useMemo, useState} from 'react';
import {useIsomorphicLayoutEffect} from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

export function useMatchesMediaQuery(mediaQuery: string) {
  const query = useMemo(
    () =>
      'matchMedia' in globalThis ? globalThis.matchMedia(mediaQuery) : null,
    [mediaQuery],
  );

  const [matches, setMatches] = useState(false);

  useIsomorphicLayoutEffect(() => {
    setMatches(query?.matches ?? false);
  }, [query]);

  useEffect(() => {
    if (query) {
      const listener = ({matches}: MediaQueryListEvent) => {
        // TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
        // eslint-disable-next-line local-rules/set-state-in-use-effect
        setMatches(matches);
      };
      query.addListener(listener);

      return () => {
        query.removeListener(listener);
      };
    }
  }, [query]);

  return matches;
}
